import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';
import Button from 'components/base/Button';
import { useAuth } from 'providers/AuthProvider';

const AnalyticsDashboard = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const auth = useAuth();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Analytics.page_title'),
            active: true
        }
    ];


    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />

            <Card className='border border-light rounded-5 mb-2 pb-2' >
                <Card.Body>
                    <div className='align-content-center '>
                        <p className="mb-0 mx-3 fs-8"> {t("Analytics.headline")}</p>
                        <p className="mt-0 mx-3 fs-8"> {t("MySkills.headline2")}</p>
                    </div>
                </Card.Body>
            </Card>

            <Card className="border border-light rounded-5 mt-3 mb-3 pb-2">
                <Card.Body>
                    <Card.Title>{t("StatisticsDashboard.basic_stats.title")}</Card.Title>

                    <div className="row w-100 gx-4">
                        <div className="col-12 col-md-6 mb-3">
                            <Button
                                onClick={() => navigate("/analytics/statistics/engagement")}
                                variant="soft-info"
                                className="w-100 fs-7 rounded-5"
                                style={{ height: "100px" }}
                            >
                                {t("StatisticsDashboard.basic_stats.engagement")}
                            </Button>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                            <Button
                                onClick={() => navigate("/analytics/statistics/task-management")}
                                variant="soft-info"
                                className="w-100 fs-7 rounded-5"
                                style={{ height: "100px" }}
                            >
                                {t("StatisticsDashboard.basic_stats.tasks_completion")}
                            </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="border border-light rounded-5 mt-3 mb-3 pb-2">
                <Card.Body>
                    <Card.Title>{t("StatisticsDashboard.development_areas.title")}</Card.Title>

                    <div className="row w-100 gx-4">
                        <div className="col-12 col-md-6 mb-3">
                            <Button
                                onClick={() => navigate("/analytics/skills-tracker")}
                                variant="soft-info"
                                className="w-100 fs-7 rounded-5"
                                style={{ height: "100px" }}
                            >
                                {t("StatisticsDashboard.development_areas.skills")}
                            </Button>
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            <Button
                                onClick={() => navigate("/analytics/work-life-balance-tracker")}
                                variant="soft-info"
                                className="w-100 fs-7 rounded-5"
                                style={{ height: "100px" }}
                            >
                                {t("StatisticsDashboard.development_areas.wlbalance")}
                            </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>


            {auth.user?.is_coach && <Card className="border border-light rounded-5 mt-3 mb-3 pb-2">
                <Card.Body>
                    <Card.Title>For Coaches</Card.Title>

                    <div className="row w-100 gx-4 align-items-stretch">
                        <div className="col-12 col-md-6 mb-3">
                            <Button
                                variant="soft-info"
                                className="w-100 fs-7 rounded-5 h-100"
                                style={{ minHeight: "100px" }}
                            >
                                Your Coaching Competencies
                            </Button>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                            <Card className="border border-light rounded-5 h-100">
                                <Card.Body className="d-flex align-items-center">
                                    <p className="mb-0 fs-8">
                                        Analyse your coaching sessions and receive data-driven feedback
                                        aligned with ICF core competencies. You can upload a recording or a
                                        transcript.
                                    </p>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </Card.Body>
            </Card>
            }


            {/* 
            <Button onClick={() => navigate("/analytics/skills-tracker")} variant="soft-info" className="flex-grow-1 mx-4 fs-7 rounded-4" style={{ height: '100px' }}>{t("StatisticsDashboard.development_areas.skills")}</Button>
            <Button onClick={() => navigate("/analytics/work-life-balance-tracker")} variant="soft-info" className="flex-grow-1 mx-4 fs-7 rounded-4" style={{ height: '100px' }}>{t("StatisticsDashboard.development_areas.wlbalance")}</Button>
            <Button onClick={() => navigate("/analytics/coaching-stats")} variant="soft-info" className="flex-grow-1 mx-4 fs-7" style={{ height: '70px' }}>{t("StatisticsDashboard.development_areas.coaching")}</Button>
            <Button variant="soft-info" className="flex-grow-1 mx-4 fs-7" style={{ height: '70px' }}>{t("StatisticsDashboard.development_areas.impact")}</Button>
            <Button onClick={() => navigate("/analytics/skills-tracker")} variant="soft-info" className="flex-grow-1 mx-4 fs-7 rounded-4" style={{ height: '100px' }}>{t("StatisticsDashboard.development_areas.skills")}</Button>
        */}

        </>
    );
};

export default AnalyticsDashboard;
